import { useState, useCallback, useEffect } from "react";
import {
  DivForm,
  TopGrid,
  Title,
  Grid,
  TitleValue,
  TextValue,
  TextValueDecoration,
  GridButtons,
  SetaVoltar,
  TitleStatus,
  BtnContact,
  BtnPDF,
  TextArea,
  ButtonOK,
  ButtonDelete,
  GridInputs,
  CommitmentsContainer,
  Container,
  CommitmentsGrid,
  CommitmentCard,
  CommitmentDescription,
  CommitmentDate,
  NoCommitmentsText,
} from "./styles";
import { Tooltip } from "@material-ui/core";
import checkIcon from "../Toast/Image/check.svg";
import errorIcon from "../Toast/Image/error.svg";
import { useAPI } from "../../hooks/contextApis";
import { useProgress } from "../../hooks/progress";
import SetaVoltarImg from "../../assets/images/SetaVoltar.png";
import info from "../../assets/images/Info.svg";
import lixo from "../../assets/images/Lixo.png";
import relogio from "../../assets/images/icons/Relogio.svg";
import cancelar from "../../assets/images/icons/Cancelar.svg";
import check from "../../assets/images/icons/Check.svg";

import api from "../../services/api/index";
import { readDataStorage } from "../../utils/storage/storage";
import Toast from "../Toast/Toast";
import Modal from "../Modais/ModalConfirmDelete";
import ModalCancel from "../Modais/ModalConfirmCancel";
import { ModalUploadAttatchment } from "./ModalUploadAttatchment";
import DeleteIcon from "@mui/icons-material/Delete";
import { PDFPropostaButton } from "../GeraPDFProposta";
import { IconButton, Stack, Typography } from "@mui/material";
import NovoCompromisso from "./NovoCompromisso";
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';


export function ViewUser() {
  const {
    TipoVendedor,
    CpfRepresentante,
    CnpjRepresentante,
    Equipe,
    Regional,
  } = readDataStorage("login");
  
  const {
    dataUser,
    isEditing,
    modalIsOpenCancel,
    newActive,
    setIsOpenCancel,
    handleActive,
    setIsOpenUser,
    setDados,
    setIsEditing,
  } = useAPI();
  const { isLoad, setLoad } = useProgress();
  const [title, setTitle] = useState<string>("Copiar link");
  const [list, setList] = useState<unknown[]>([]);
  const [openText, setOpenText] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalIsOpenUpload, setIsOpenUpload] = useState(false);

  const defaultText = "Observações da proposta";
  const [text, setText] = useState(defaultText);
  const [commitments, setCommitments] = useState([]);
  const [selectedCommitment, setSelectedCommitment] = useState(null);
  const [mostrarCompromisso, setMostrarCompromisso] = useState(false);
  dayjs.locale('pt-br');

  const abrirNovoCompromisso = () => {
    setMostrarCompromisso(true);
  };

  const fecharNovoCompromisso = () => {
    fetchCommitments();
    setMostrarCompromisso(false);
    setSelectedCommitment(null);
  };

  const fetchCommitments = async () => {
    try {
      const response = await api.get(
        `/csp/representante/compromissos/consultar?cpf=${CpfRepresentante}`
      );
      const filteredCommitments = (response.data.compromissos || []).filter(
        (compromisso: any) => compromisso?.idCard === dataUser?.idCard
      );
      setCommitments(filteredCommitments);
    } catch (error) {
      console.error("Erro ao buscar compromissos:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (CpfRepresentante) {
      fetchCommitments();
    }
    // eslint-disable-next-line
  }, [CpfRepresentante]);

  const fetchCommitmentDetails = async (id: any) => {
    try {
      const response = await api.get(
        `/csp/representante/compromissos/especifico/${id}`
      );
      setSelectedCommitment({
        ...response.data,
        id: id,
      });
      setMostrarCompromisso(true);
    } catch (error) {
      console.error("Erro ao buscar detalhes do compromisso:", error);
    }
  };

  const [attachments, setAttachments] = useState<string[]>(() => {
    try {
      return JSON.parse(dataUser?.fatura || "[]");
    } catch (error) {
      console.error("Invalid JSON format:", error);
      return [];
    }
  });

  useEffect(() => {
    setAttachments(() => {
      try {
        return JSON.parse(dataUser?.fatura || "[]");
      } catch (error) {
        console.error("Invalid JSON format:", error);
        return [];
      }
    });
  }, [dataUser]);

  const updateData = useCallback(
    (id) => {
      setLoad(true);
      api.get(`/csp/cliente/consultar/card/` + id).then((res) => {
        const mensagemElement = document.getElementById(
          "mensagem"
        ) as HTMLTextAreaElement | null;
        if (mensagemElement) {
          mensagemElement.value = res.data?.observa_o ?? "";
        }

        setLoad(false);
        setIsEditing(false);
        setIsOpenCancel(false);
      });
    },
    [setLoad, setIsEditing, setIsOpenCancel]
  );

  const handleSaveObs = () => {
    setLoad(true);
    api.defaults.headers.common = {
      Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
    };
    api
      .post(`/csp/usuario/alterar/observacao`, {
        idCard: dataUser?.idCard,
        observacao: text,
      })
      .then((res) => {
        setLoad(false);
      })
      .catch((error) => {
        if (error.response.status >= 400) {
          setLoad(false);
        }
        setLoad(false);
      });
  };

  const handleCancel = () => {
    setText(dataUser?.observa_o);
    const mensagemElement = document.getElementById(
      "mensagem"
    ) as HTMLTextAreaElement | null;
    if (mensagemElement) {
      mensagemElement.value = dataUser?.observa_o ?? "";
    }
    setIsEditing(false);
  };

  const handleBackCancel = () => {
    setText(dataUser?.observa_o || defaultText);

    if (isEditing) {
      setIsOpenCancel(true);
    } else {
      setIsOpenUser(false);
    }
  };

  const handleConfirmCancel = useCallback(() => {
    handleActive(newActive);
    setIsOpenUser(false);
    updateData(dataUser?.idCard);
  }, [updateData, dataUser?.idCard, setIsOpenUser, handleActive, newActive]);

  const handleSave = () => {
    handleSaveObs();
    setIsEditing(false);
  };

  const handleChange = (event: any) => {
    setText(event.target.value);
    setIsEditing(true);
  };

  const limparNumero = (numero: any) => {
    return numero?.replace(/\D/g, "");
  };
  const emailLink = "mailto:" + dataUser?.email;
  const telefone = `https://wa.me/${limparNumero(
    dataUser?.telefone_do_titular_da_conta
  )}`;

  let toastProperties: unknown = null;
  const showToast = useCallback(
    (type) => {
      const id = Math.floor(Math.random() * 101 + 1);

      switch (type) {
        case "copied":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Link copiado para área de transferência!",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        case "downloaded":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Imagem do QR Code baixada com sucesso!",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        case "excluida":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Proposta excluída!",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        case "faturaExcluida":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Fatura excluída!",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        case "errorSend":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Erro ao excluir fatura",
            backgroundColor: "#b85c5c",
            icon: checkIcon,
          };
          break;
        case "successContact":
          toastProperties = {
            id,
            title: "",
            description: "Contrato enviado",
            backgroundColor: "#f0ad4e",
            icon: checkIcon,
          };
          break;
        case "warningContact":
          toastProperties = {
            id,
            title: "",
            description: "Contrato não encontrado",
            backgroundColor: "#f0ad4e",
            icon: errorIcon,
          };
          break;
        case "limitSend":
          toastProperties = {
            id,
            title: "",
            description: "Limite de reenvio atingido",
            backgroundColor: "#f0ad4e",
            icon: errorIcon,
          };
          break;
        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [toastProperties]
  );

  const handleClickText = () => {
    setOpenText(!openText);
  };

  const handleReSendContact = () => {
    setLoad(true);
    api
      .post(`/csp/representante/contrato/reenvio/`, {
        idCard: dataUser?.idCard,
      })
      .then((res) => {
        if (res.status === 200) {
          setLoad(false);
          showToast("successContact");
          updateData(dataUser?.idCard);
        }
        if (res.status === 202) {
          setLoad(false);
          showToast("limitSend");
          updateData(dataUser?.idCard);
        }
      })
      .catch((error) => {
        if (error.response.status >= 400) {
          showToast("warningContact");
          setLoad(false);
        }
        setLoad(false);
      });
  };

  async function copy() {
    try {
      await navigator.clipboard.writeText(dataUser?.link_da_proposta);
      setTitle("Copiado");
      showToast("copied");

      setTimeout(() => {
        setTitle("Copiar link");
      }, 1000);
    } catch (err) {
      console.error("Falha ao copiar o link: ", err);
    }
  }

  const dataSend = useCallback((id, tipo, formato) => {
    let object = {
      id: id,
      tipo: tipo,
      formato: formato,
    };
    return object;
  }, []);

  const handleExit = useCallback(() => {
    setOpenText(false);
    setIsOpenUser(false);
  }, [setOpenText, setIsOpenUser]);

  const handleBack = useCallback(async () => {
    switch (TipoVendedor) {
      case "Representante Legal":
        setDados(dataSend(CnpjRepresentante, "rep", "cnpj"));
        handleExit();
        break;
      case "Vendedor":
        setDados(dataSend(CpfRepresentante, "ven", "cpf"));
        handleExit();
        break;
      case "Coordenador de Equipes":
        setDados(dataSend(Equipe, "equipe", "equipe"));
        handleExit();
        break;
      case "Gerente de Equipes":
        setDados(dataSend(Regional, "regional", "regional"));
        handleExit();
        break;
      default:
        //setDados(CnpjRepresentante)
        break;
    }
  }, [
    TipoVendedor,
    dataSend,
    setDados,
    CnpjRepresentante,
    CpfRepresentante,
    Equipe,
    handleExit,
    Regional,
  ]);

  const handleExclude = () => {
    setLoad(true);
    api.defaults.headers.common = {
      Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
    };
    api
      .post(`/csp/representante/excluir/card/`, {
        idCard: dataUser?.idCard,
      })
      .then((res) => {
        setLoad(false);
        showToast("excluida");
        setTimeout(() => {
          handleBack();
        }, 500);
      })
      .catch((error) => {
        if (error.response.status >= 400) {
          showToast("warning");
          setLoad(false);
        }
        setLoad(false);
      });
  };

  const AttachmentsDisplay = (attachments: { fatura: string[] }) => {
    const handleClick = (url: string) => {
      window.open(url, "_blank", "noopener,noreferrer");
    };

    const onDeleteFile = useCallback(
      async (fullUrl: string): Promise<number> => {
        try {
          setLoad(true);
          const url = new URL(fullUrl);
          const pathname = url.pathname;
          const uploadsIndex = pathname.indexOf("/uploads");
          const specificPath = pathname.substring(uploadsIndex + 1);

          const response = await api.post("/csp/fatura/excluir", {
            idCard: String(dataUser?.idCard),
            fotos: specificPath,
          });

          if (response.status === 200) {
            showToast("faturaExcluida");
            const updatedFotos = attachments.fatura.filter(
              (url) => url !== fullUrl
            );
            setAttachments(updatedFotos);
          }
          setLoad(false);
          return response.status;
        } catch (error) {
          setLoad(false);
          showToast("errorSend");
          return 500;
        }
      },
      [attachments]
    );

    return (
      <Stack
        sx={{
          flexWrap: "wrap",
          flexDirection: "row",
          gap: 1,
          maxWidth: 922,
          margin: "0 auto",
        }}
      >
        {!attachments.fatura.length && <p>Nenhuma fatura disponível.</p>}

        {attachments.fatura.map((url, index) => {
          const fileName =
            url.split("/").pop()?.split("?")[0] ?? `Arquivo ${index + 1}`;

          return (
            <Stack
              key={index}
              direction="row"
              alignItems="center"
              onClick={() => handleClick(url)}
              sx={{
                minHeight: 44,
                overflow: "hidden",
                cursor: "pointer",
                borderRadius: 2,
                border: "1px solid rgb(217, 217, 217)",
                width: "100%",
                maxWidth: { xs: "auto", md: 360 },
              }}
            >
              <Typography
                sx={{
                  flex: 1,
                  px: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {fileName}
              </Typography>

              <Tooltip title="Excluir anexo">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteFile(url);
                  }}
                >
                  <DeleteIcon style={{ color: "#333333" }} />
                </IconButton>
              </Tooltip>
            </Stack>
          );
        })}
      </Stack>
    );
  };

  const closeModal = () => {
    setIsOpen(false);
    setIsOpenUpload(false);
    setIsOpenCancel(false);
  };

  const closeDelete = () => {
    handleExclude();
  };

  const dataPDF = useCallback((data: any) => {
    let object: any = {
      idCard: data?.idCard,
      tipoPessoa: data?.tipo,
      endereco: {
        CEP: data?.cep,
        logradouro: data?.rua,
        numero: data?.n_mero,
        complemento: data?.complemento,
        bairro: data?.bairro,
        cidade: data?.cidade,
        estado: data?.estado,
      },
      fatura: {
        concessionaria: data?.concession_ria,
        numeroInstalacao: data?.n_mero_da_instala_o_cemig_1,
        dataVencimentoFatura: data?.data_de_vencimento_da_fatura_cemig,
      },
      dadosBancario: {
        formaPagamento: data?.forma_de_pagamento,
      },

      pessoaFisica: {
        nomeCompleto: data?.empresa,
        CPF: data?.cpf,
        dataNascimento: data?.data_de_nascimento_do_titular,
        email: data?.email,
        telefone: data?.telefone_do_titular_da_conta,
      },
      pessoaJuridica: {
        responsavel: {
          CPF: data.cpf_do_respons_vel_legal,
          dataNascimento: data.data_de_nascimento_do_titular,
          nomeCompleto: data.nome_do_respons_vel_legal,
          email: data.email_do_respons_vel_legal,
          telefone: data.telefone_do_respons_vel_legal,
        },
      },
    };
    return object;
  }, []);

  const dataDetalhamento = useCallback((data: any) => {
    let object: any = {
      carbonoEvitado: data?.carbonoEvitado,
      arvoresCultivadas: data?.arvoresCultivadas,
      kmCarroEletrico: data?.kmCarroEletrico,
      geracaoAnual: data?.gera_o_anual_contratada_2,
      consumoMedio: data?.m_dia_de_consumo,
    };
    return object;
  }, []);

  const { handleClickPage } = useAPI();

  const handleDuplicate = useCallback(() => {
    sessionStorage.setItem("@ARP-Energia:duplicado", JSON.stringify(dataUser));
    handleClickPage("GPCR");
    setIsOpenUser(false);
  }, [dataUser, handleClickPage, setIsOpenUser]);

  return (
    <>

      {mostrarCompromisso ? (
        <NovoCompromisso
          compromisso={selectedCommitment}
          onClose={fecharNovoCompromisso}
        />
      ) : (
        <>
          <Toast toastList={list} autoDelete={true} />
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            onRequestCloseDelete={closeDelete}
          />
          <ModalUploadAttatchment
            isOpen={modalIsOpenUpload}
            onClose={closeModal}
            idCard={dataUser?.idCard}
          />
          <ModalCancel
            isOpen={modalIsOpenCancel}
            onRequestClose={closeModal}
            onRequestCloseCancel={handleConfirmCancel}
          />

          <DivForm>
            <TopGrid>
              <SetaVoltar
                alt=""
                src={SetaVoltarImg}
                onClick={handleBackCancel}
              ></SetaVoltar>
              <TitleStatus>
                {dataUser?.empresa} - {dataUser?.status_arp}{" "}
                <img
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                  src={lixo}
                  alt=""
                  onClick={() => setIsOpen(true)}
                  width={24}
                />
              </TitleStatus>
            </TopGrid>
            <Title>Dados da proposta</Title>
            <Grid>
              <div>
                <TitleValue>ID Card</TitleValue>
                <TextValue>{dataUser?.idCard}</TextValue>
              </div>
              <div>
                <TitleValue>Data de criação</TitleValue>
                <TextValue>{dataUser?.criacaoCard}</TextValue>
              </div>
              <div>
                <TitleValue>Data de atualização</TitleValue>
                <TextValue>{dataUser?.dataAlteracao}</TextValue>
              </div>
              <div>
                <TitleValue>Descrição do status</TitleValue>
                <TextValue>
                  {dataUser?.descri_o}
                  <img
                    style={{ cursor: "pointer", marginLeft: "5px" }}
                    src={info}
                    alt=""
                    onClick={handleClickText}
                    width={20}
                  />
                  <div className={`${openText ? "show" : "hide"}`}>
                    {dataUser?.descri_o}
                  </div>
                </TextValue>
              </div>
            </Grid>

            <Title>Dados do contratante</Title>
            <Grid>
              <div>
                <TitleValue>Nome do titular da conta</TitleValue>
                <TextValue>{dataUser?.empresa}</TextValue>
              </div>
              <div>
                <TitleValue>E-mail</TitleValue>
                <TextValue>
                  <TextValueDecoration href={emailLink}>
                    {dataUser?.email}
                  </TextValueDecoration>
                </TextValue>
              </div>
              <div>
                <TitleValue>WhatsApp</TitleValue>
                <TextValue>
                  <TextValueDecoration
                    style={{ cursor: "pointer" }}
                    target="_blank"
                    rel="noreferrer"
                    href={telefone}
                  >
                    {" "}
                    {dataUser?.telefone_do_titular_da_conta}
                  </TextValueDecoration>
                </TextValue>
              </div>
              <div>
                <TitleValue>Telefone</TitleValue>
                <TextValue>{dataUser?.telefone_do_titular_da_conta}</TextValue>
              </div>
            </Grid>

            <Title>Dados de endereço</Title>
            <Grid>
              <div>
                <TitleValue>CEP</TitleValue>
                <TextValue>{dataUser?.cep}</TextValue>
              </div>
              <div>
                <TitleValue>Logradouro</TitleValue>
                <TextValue>{dataUser?.rua}</TextValue>
              </div>
              <div>
                <TitleValue>Cidade</TitleValue>
                <TextValue>{dataUser?.cidade}</TextValue>
              </div>
              <div>
                <TitleValue>Estado</TitleValue>
                <TextValue>{dataUser?.estado}</TextValue>
              </div>
            </Grid>

            <Title>Dados da fatura</Title>
            <Grid>
              <div>
                <TitleValue>Concessionária</TitleValue>
                <TextValue>{dataUser?.concession_ria}</TextValue>
              </div>
              <div>
                <TitleValue>Número de instalação</TitleValue>
                <TextValue>{dataUser?.n_mero_da_instala_o_cemig_1}</TextValue>
              </div>
              <div>
                <TitleValue>Valor AXS</TitleValue>
                <TextValue>R$ {dataUser?.mensalidade_axs}</TextValue>
              </div>
            </Grid>
            <br />

            <GridInputs>
              <Title>Link da proposta</Title>
              <div style={{ display: "flex" }}>
                <input
                  className="input-link"
                  type="text"
                  value={dataUser?.link_da_proposta}
                />
                <Tooltip title={title} placement="top" arrow>
                  <button className="copy-button" type="button" onClick={copy}>
                    Copiar link
                  </button>
                </Tooltip>
              </div>
              <br />
              <TextArea
                id="mensagem"
                defaultValue={dataUser?.observa_o}
                onChange={handleChange}
                maxLength={500}
                placeholder={defaultText}
              ></TextArea>
              {isEditing && (
                <div>
                  <ButtonOK disabled={isLoad} onClick={handleSave}>
                    Salvar
                  </ButtonOK>
                  <ButtonDelete disabled={isLoad} onClick={handleCancel}>
                    Cancelar
                  </ButtonDelete>
                </div>
              )}
            </GridInputs>
            <br />

            <GridInputs>
            
              <Container>
              <Title>Compromissos</Title>
                <BtnContact
                  onClick={abrirNovoCompromisso}
                  disabled={commitments.some(
                    (compromisso: any) => compromisso.status === "Ativo"
                  )}
                >
                  Novo compromisso
                </BtnContact>
              </Container>
              <CommitmentsContainer>
                <CommitmentsGrid>
                  {commitments.length > 0 ? (
                    [...commitments]
                      .sort((a: any, b: any) =>
                        a.status === "Ativo" ? -1 : b.status === "Ativo" ? 1 : 0
                      )
                      .map((compromisso: any) => {
                        const isDisabled =
                          compromisso.status === "Cancelado" ||
                          compromisso.status === "Concluído";

                        return (
                          <CommitmentCard
                            key={compromisso.id}
                            status={compromisso.status}
                            onClick={
                              !isDisabled
                                ? () => fetchCommitmentDetails(compromisso.id)
                                : undefined
                            }
                            style={{
                              opacity: isDisabled ? 0.6 : 1,
                              cursor: isDisabled ? "default" : "pointer",
                              pointerEvents: isDisabled ? "none" : "auto",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "12px",
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                              backgroundColor: "#fff",
                              display: "grid",
                              gridTemplateColumns: "auto auto",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <CommitmentDescription
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#000",
                                }}
                              >
                                {compromisso.descricao}
                              </CommitmentDescription>

                              <CommitmentDate
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#5A3DFF",
                                }}
                              >
                                {new Date(
                                  compromisso.dataHoraComp
                                ).toLocaleDateString("pt-BR", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })}{" "}
                                {new Date(
                                  compromisso.dataHoraComp
                                ).toLocaleTimeString("pt-BR", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </CommitmentDate>
                            </div>

                            <img
                              src={
                                compromisso.status === "Ativo"
                                  ? relogio
                                  : compromisso.status === "Cancelado"
                                  ? cancelar
                                  : compromisso.status === "Concluído"
                                  ? check
                                  : ""
                              }
                              alt="Status"
                              width={25}
                              height={25}
                              style={{ marginLeft: "10px" }}
                            />
                          </CommitmentCard>
                        );
                      })
                  ) : (
                    <NoCommitmentsText>
                      Nenhum compromisso encontrado.
                    </NoCommitmentsText>
                  )}
                </CommitmentsGrid>
              </CommitmentsContainer>
            </GridInputs>
            <Title>Anexos da proposta</Title>
            <AttachmentsDisplay fatura={attachments} />
            <br />
            <GridButtons>
              <BtnContact onClick={() => setIsOpenUpload(true)}>
                Adicionar arquivo
              </BtnContact>

              <BtnContact
                onClick={handleReSendContact}
                disabled={
                  !(
                    (dataUser?.status_arp === "Aguardando Assinatura" &&
                      dataUser?.chave_whatsapp !== null &&
                      dataUser?.total_reenvio_contrato < "1") ||
                    !dataUser?.total_reenvio_contrato
                  ) || isLoad
                }
              >
                Reenviar contrato
              </BtnContact>

              <BtnPDF>
                <PDFPropostaButton
                  data={dataPDF(dataUser)}
                  detalhamento={dataDetalhamento(dataUser)}
                  detalhamentoEconomia={dataUser?.economia_anual}
                  mensalidade={dataUser?.mensalidade_axs}
                  urlDoLinkProsseguirAssinatura={dataUser?.link_da_proposta}
                />
              </BtnPDF>

              <BtnContact type="button" onClick={handleDuplicate}>
                Duplicar proposta
              </BtnContact>
            </GridButtons>
          </DivForm>
        </>
      )}
    </>
  );
}
